EncoursController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$translate',
    'ModalService',
    'PaginationService',
    'EncoursService',
    'notification',
    'CentreGestionService',
    'moment',
    'globalizationManagementService',
    'MassiaAuthService'
];

export default function EncoursController(
    $scope,
    $state,
    $stateParams,
    $translate,
    ModalService,
    PaginationService,
    EncoursService,
    notification,
    CentreGestionService,
    moment,
    globalizationManagementService,
    MassiaAuthService
) {
    const vm = this;

    let previousTableState;
    // const watchers = [];

    vm.loading = false;
    vm.params = $stateParams;
    vm.state = $state;
    vm.moment = moment;
    vm.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
    vm.encours = [];
    vm.CentreGestionService = CentreGestionService;
    vm.parametersGroup = [];
    vm.getElementData = getElementData;

    vm.slideWidth = '500px';
    vm.slideMargin = {
        'margin-right': '0px',
        'transition-duration': '0.5s',
        'transition-animation': 'margin-right',
        height: '100%'
    };
    vm.itemsByPageOptions = [50, 200, 1000];
    vm.itemsByPage = vm.itemsByPageOptions[0];

    vm.requeteId = 0;
    vm.loadEncours = loadEncours;
    vm.getClients = getClients;
    vm.reset = reset;
    vm.exporter = exporter;
    vm.calculer = calculer;
    vm.toggleEditMode = toggleEditMode;
    vm.updateEncourParameter = updateEncourParameter;
    vm.handleEncours = handleEncours;
    vm.readDefaultFilters = readDefaultFilters;
    vm.MassiaAuthService = MassiaAuthService;

    async function init() {
        await getSocietesCom();
        await getLastDateCalculAuto();
        vm.isAlerte = '0';
        vm.isDepasse = '0';
    }

    init();

    async function getSocietesCom() {
        vm.societes = await EncoursService.getSocietesCom();
        if (vm.societes.length == 1) {
            vm.societeId = vm.societes[0].id;
        }
    }

    async function getLastDateCalculAuto() {
        const lastDate = await EncoursService.getLastDateCalculAuto();
        vm.lastDateAuto = $translate.instant('ENCOURS.MSG_LAST_DATE_AUTO', { date: lastDate.dateAuto });
        vm.lastDateManuelle = lastDate.dateManuelle;
    }

    async function getClients(valeur) {
        const clients = await EncoursService.getClients(valeur);
        return clients;
    }

    async function loadEncours(tableState) {
        startLoading();

        vm.requeteId++;
        const currentRequeteId = vm.requeteId;

        if ($state && $state.current && $state.current.name !== 'encours.list') {
            $state.go('encours.list');
        }

        if (tableState) {
            previousTableState = tableState;
        }

        const filters = PaginationService.getFilters(previousTableState);
        const sorts = PaginationService.getSorts(previousTableState);
        const pagination = PaginationService.getPagination(previousTableState);

        vm.encours = [];

        try {
            const isEncoursAlerte = !vm.isAlerte || vm.isAlerte == '0' ? null : vm.isAlerte == '1' ? true : false;
            const isEncoursDepasse = !vm.isDepasse || vm.isDepasse == '0' ? null : vm.isDepasse == '1' ? true : false;
            const data = await EncoursService.getEncours(
                filters,
                sorts,
                pagination,
                vm.societeId,
                vm.client ? vm.client.id : null,
                isEncoursAlerte,
                isEncoursDepasse
            );

            if (currentRequeteId !== vm.requeteId) {
                return;
            }
            vm.encours = data.items;

            if (previousTableState) {
                PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
            }
        } catch (ex) {
            notification.error(ex.data);
        } finally {
            stopLoading();
        }
    }

    function reset() {
        vm.isAlerte = '0';
        vm.isDepasse = '0';
        vm.client = null;
        vm.encours = [];
        getSocietesCom();

        const defaultData = vm.readDefaultFilters();
        const id = defaultData?.idSociete;
        if (id != null) {
            vm.societeId = Number(id);
            loadEncours();
        } else {
            vm.societeId = null;
        }
    }

    function readDefaultFilters() {
        const user = vm.MassiaAuthService.getAuthenticatedUser();
        if (!user) return null;
        const userId = user.id || user.userId || user.login;
        try {
            const raw = localStorage.getItem(`massia_default_filters_${userId}`);
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            return null;
        }
    }

    async function exporter(modeImpression) {
        try {
            const filters = PaginationService.getFilters(previousTableState);
            const sorts = PaginationService.getSorts(previousTableState);
            const fileName = 'Liste_encours';
            let resultat = undefined;
            try {
                const isEncoursAlerte = vm.isAlerte == '0' ? null : vm.isAlerte == '1' ? true : false;
                const isEncoursDepasse = vm.isDepasse == '0' ? null : vm.isDepasse == '1' ? true : false;
                resultat = await EncoursService.export(
                    modeImpression,
                    filters,
                    sorts,
                    vm.societeId,
                    vm.client ? vm.client.id : null,
                    isEncoursAlerte,
                    isEncoursDepasse
                );
            } catch (ex) {
                //si on a des exception à afficher, le faire de cette manière à cause du format de retour de type fichier
                const msgException = String.fromCharCode.apply(null, new Uint8Array(ex.data));
                notification.error('ENCOURS.' + msgException);
                return false;
            }
            if (resultat) {
                const data = resultat.data;
                let headers = resultat.headers;
                headers = headers();

                const contentType = headers['content-type'];

                const linkElement = document.createElement('a');
                try {
                    const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
                    const url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    if (modeImpression == 0) {
                        linkElement.setAttribute('download', fileName + '.pdf');
                    } else {
                        linkElement.setAttribute('download', fileName + '.xlsx');
                    }

                    const clickEvent = new MouseEvent('click', {
                        view: window,
                        bubbles: true,
                        cancelable: false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log('🚀 ~ exporter ~ ex:', ex);
                }
                return true;
            }
        } catch (ex) {
            this.notification.error(ex.data);
            return false;
        }
    }

    async function calculer() {
        if (vm.lastDateManuelle) {
            const modalInstance = ModalService.confirm({
                modalTitle: $translate.instant('ENCOURS.CALCUL_POPUP.TITLE'),
                modalMsg: $translate.instant('ENCOURS.CALCUL_POPUP.MESSAGE', { date: vm.lastDateManuelle }),
                headerClass: 'modal-danger'
            });

            modalInstance.result.then(calculEncours);
        } else {
            calculEncours();
        }
    }

    async function calculEncours() {
        startLoading();
        try {
            notification.success($translate.instant('ENCOURS.CALCUL_POPUP.SUCCESS'));
        } catch (ex) {
            notification.error(ex.data);
        } finally {
            loadEncours();
            stopLoading();
        }
    }

    function startLoading() {
        vm.loading = true;
    }

    function stopLoading() {
        vm.loading = false;
    }

    // function dispose() {
    // 	watchers.forEach((x) => x());
    // }

    async function toggleEditMode(encours) {
        encours.isEditMode = !encours.isEditMode;

        if (encours.isEditMode) {
            const params = await vm.CentreGestionService.getParametersWithFilter('SiteClient', encours.idClient, {
                clientId: encours.idClient,
                date: vm.moment().format(vm.dateFormat),
                typeClientId: encours.typeClientId,
                hasToCheckPont: false,
                societeId: encours.idSociete
            });
            const parameters = params
                .flatMap((x) => x.parametres)
                .filter((x) => x.codeParametre == 'MontantEncours' || x.codeParametre == 'pourcentAlerteEncours');
            vm.parametersGroup.push({
                codeClient: encours.codeClient,
                parameters: parameters
            });
        }
    }

    async function updateEncourParameter(encours) {
        const encoursdataIndex = vm.parametersGroup.findIndex((x) => x.codeClient == encours.codeClient);
        const [encoursdata] = encoursdataIndex !== -1 ? vm.parametersGroup.splice(encoursdataIndex, 1) : [null];
        const montantEncours = encoursdata.parameters.find((x) => x.codeParametre == 'MontantEncours');
        const pourcentAlerteEncours = encoursdata.parameters.find((x) => x.codeParametre == 'pourcentAlerteEncours');

        await vm.handleEncours(montantEncours, encours.encoursAutorise, encours.isEncoursAutoriseFromType, encours);
        await vm.handleEncours(pourcentAlerteEncours, encours.pourcentAlerte, encours.isPourcentAlerteFromType, encours);

        encours.isEditMode = false;
        vm.loadEncours();
    }

    async function handleEncours(parameter, value, isFromType, encours) {
        const element = vm.getElementData(parameter.donnees[1], encours);
        if ((value == '' || +value === 0) && +element.valeur !== 0 && !isFromType) {
            await vm.CentreGestionService.effacer(element.id);
            notification.success($translate.instant('CENTRE_GESTION.ON_DELETE'));
        } else if (+value && +element.valeur !== 0 && !isFromType) {
            if (+value != +element.valeur) {
                element.valeur = value;

                try {
                    await vm.CentreGestionService.update(element);
                    notification.success($translate.instant('CENTRE_GESTION.ON_UPDATE'));
                } catch (ex) {
                    notification.error(ex.data);
                }
            }
        } else {
            if (+value && +element.valeur !== +value) {
                element.valeur = value;

                try {
                    await vm.CentreGestionService.insert(element);
                    notification.success($translate.instant('CENTRE_GESTION.ON_SAVE'));
                } catch (ex) {
                    notification.error(ex.data);
                }
            }
        }
    }

    function getElementData(object, encours) {
        const element = object.valeurs[0];
        element.dateApplication = vm.moment().format(vm.dateFormat);
        element.codeDomaine = 'SiteClient';
        element.entreeSortie = 1;
        element.clientId = encours.idClient;
        element.societeId = encours.idSociete;
        return element;
    }
}
